import { MenuItem, Select, Typography } from "@mui/material";

interface UnitsProps {
  options: string[];
  selectedUnit: string;
  setSelectedUnit: (value: string) => void;
}

// Component to display the given measurement units in a dropdown
export default function Units({
  options,
  selectedUnit,
  setSelectedUnit,
}: UnitsProps): JSX.Element {
  return (
    <Select
      sx={{
        width: "75px",
        height: "40px",
      }}
      value={selectedUnit}
      onChange={(event) => setSelectedUnit(event.target.value)}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          <Typography variant="body1">{option}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
}
